import { render } from "./coursewareList.vue?vue&type=template&id=01e7e0be&scoped=true"
import script from "./coursewareList.vue?vue&type=script&lang=js"
export * from "./coursewareList.vue?vue&type=script&lang=js"

import "./coursewareList.vue?vue&type=style&index=0&id=01e7e0be&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e7e0be"]])

export default __exports__